import * as React from 'react'
import { SVGProps } from 'react'

const SvgCryptoAlertsFaqIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M20 16a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z' fill='#3071EE' />
    <path
      opacity={0.2}
      d='M23 28h-1a1 1 0 0 1 0-2h1a3 3 0 0 0 3-3v-1a1 1 0 0 1 2 0v1a5.006 5.006 0 0 1-5 5Zm5-18V9a5.006 5.006 0 0 0-5-5h-1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 0 0 2 0ZM11 27a1 1 0 0 0-1-1H9a3 3 0 0 1-3-3v-1a1 1 0 1 0-2 0v1a5.006 5.006 0 0 0 5 5h1a1 1 0 0 0 1-1ZM6 10V9a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H9a5.006 5.006 0 0 0-5 5v1a1 1 0 1 0 2 0Z'
      fill='#3071EE'
    />
  </svg>
)

export default SvgCryptoAlertsFaqIcon
